import { render, staticRenderFns } from "./tjrc.vue?vue&type=template&id=c3329d2e&scoped=true&"
import script from "./tjrc.vue?vue&type=script&lang=js&"
export * from "./tjrc.vue?vue&type=script&lang=js&"
import style0 from "./tjrc.vue?vue&type=style&index=0&id=c3329d2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3329d2e",
  null
  
)

export default component.exports